<!-- eslint-disable max-len -->
<template>
  <div>
    <nav
      class="bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0"
      style="height: 50px;"
    >
    </nav>
    <div class="flex flex-col md:flex-row">
      <div class="main-content flex-1 bg-gray-100 mt-12 md:mt-2">
        <div class="bg-blue-800 p-2 shadow text-xl text-white">
          <div class="bg-grey-lighter min-h-screen flex flex-col">

            <!-- eslint-disable max-len -->
            <div
              class="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
            >
            <!-- eslint-enable max-len -->
              <div class="bg-white px-6 pt-4 pb-8 rounded shadow-md text-black w-full">
                <img class="m-auto" src="@/assets/musicverse-logo.png" style="width: 150px"/>
                <h1 class="mb-8 text-3xl text-center">{{ title }}</h1>
                <h2 class="mb-8 text-xl text-left">{{ message }}</h2>
                <h2 class="mb-8 text-xl text-left">{{ body }}</h2>
              <!-- eslint-disable-next-line max-len -->
              <!-- <h3 v-if="!isSuccessVerification" class="mb-8 text-lg font-bold">{{ email }}</h3> -->
                <button
                  v-if="!error"
                  type="submit"
                  :disabled="isLoading"
                  @click="nextProcess"
                  class="w-full
                        text-center
                        py-3 rounded
                        bg-blue-400 text-white hover:bg-blue-600 focus:outline-none my-1"
                >
                  {{ labelSave }}
                </button>
                <h1 class="mb-8 text-center" v-if="error" >
                  <!-- eslint-disable-next-line max-len -->
                  <router-link class="text-blue-400 cursor-pointer" :to="{ name: 'Signin' }" >back to login page</router-link>
                </h1>
              </div>
            </div>
            <ModalTermAndConditions
              :isShowingModal="isShowingModalTermsandCondition"
              @toggleModal="toggleModalTermsandCondition()"
              @save="verifyAccount()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import ModalTermAndConditions from '../components/Common/ModalTermAndConditions';
import clevertap from 'clevertap-web-sdk';

export default {
  name: 'VerificationEmail',
  data: () => ({
    isShowingModalTermsandCondition: true,
    message: '',
    error: null,
  }),
  props: {
    t: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    isSuccessVerification() {
      return this.message === 'Email already verified.' || this.message === 'Email verified.';
    },
    title() {
      return this.isSuccessVerification ? 'Thank you!' : 'Sorry!';
    },
    body() {
      return this.isSuccessVerification ? 'Click Login button below to login to your account.' : 'Click Send button below to resend verification email.';
    },
    labelSave() {
      return this.isSuccessVerification ? 'Login' : 'Send';
    },
  },
  methods: {
    ...mapActions('EmailModule', ['requestVerify', 'requestResendVerification']),
    ...mapActions('AuthModule', ['acceptToc']),
    async nextProcess() {
      if (this.isSuccessVerification) {
        this.$router.push({ name: 'Signin' });
      } else {
        try {
          const email = atob(this.t).split('#')[0];
          await this.requestResendVerification(email);
        } catch (err) {
          this.title = 'Sorry!';
          this.message = err.message;
          this.err = err.message;
        }
      }
    },
    async verifyAccount() {
      this.toggleModalTermsandCondition();
      try {
        const email = atob(this.t).split('#')[0];
        await this.acceptToc(email);
        const response = await this.requestVerify(this.t);
        this.message = response;
        clevertap.onUserLogin.push({
          Site: {
            Email: email,
          },
        });
        setTimeout(() => {
          clevertap.event.push('Signed Up', {
            'Method Used': 'Email',
            Email: email,
            Detail: 'Success',
            Status: 'Success',
          });
        }, 1000);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    toggleModalTermsandCondition() {
      this.isShowingModalTermsandCondition = false;
    },
  },
  components: {
    ModalTermAndConditions,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/VerificationEmail.vue